import { put, call, takeLatest } from 'redux-saga/effects';
import { routines } from '../../reducers/db/decisions';
import decisionsApi from '../../services/decisions';

function* getAllChecklistItemsForDeal({ payload }) {
  const { dealId } = payload;
  try {
    const allChecklistItems = yield call(
      decisionsApi.getAllChecklistItemsForDealList,
      dealId
    );
    yield put({
      type: routines.getAllChecklistItemsForDealList.SUCCESS,
      payload: {
        allChecklistItems
      }
    });
  } catch (error) {
    yield put({
      type: routines.getAllChecklistItemsForDealList.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getChecklistItemsForQuestion({ payload }) {
  const { question } = payload;
  try {
    const checklistItemsList = yield call(
      decisionsApi.getChecklistItemsForQuestionList,
      question
    );
    yield put({
      type: routines.getChecklistItemsForQuestionList.SUCCESS,
      payload: {
        checklistItemsList
      }
    });
  } catch (error) {
    yield put({
      type: routines.getChecklistItemsForQuestionList.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getChecklistForDealAndQuestion({ payload }) {
  const { dealId, question } = payload;
  try {
    const checklistItemsList = yield call(
      decisionsApi.getChecklistItemsForDealAndQuestionList,
      dealId,
      question
    );
    yield put({
      type: routines.getChecklistItemsForDealAndQuestionList.SUCCESS,
      payload: {
        checklistItemsList
      }
    });
  } catch (error) {
    yield put({
      type: routines.getChecklistItemsForDealAndQuestionList.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getQuestions() {
  try {
    const questionsList = yield call(decisionsApi.getQuestionsList);
    yield put({
      type: routines.getQuestionsList.SUCCESS,
      payload: {
        questionsList
      }
    });
  } catch (error) {
    yield put({
      type: routines.getQuestionsList.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getChecklistForDeal({ payload }) {
  const { dealId } = payload;
  try {
    const checklist = yield call(decisionsApi.getChecklistForDealList, dealId);
    yield put({
      type: routines.getChecklistForDealList.SUCCESS,
      payload: {
        checklist
      }
    });
  } catch (error) {
    yield put({
      type: routines.getChecklistForDealList.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* saveChecklistItems({ payload = {} }) {
  try {
    const { RequestType, ChecklistItems } = payload;
    const saveResult = yield call(
      decisionsApi.saveChecklistItems,
      RequestType,
      ChecklistItems
    );
    yield put({
      type: routines.saveChecklistItems.SUCCESS,
      payload: saveResult
    });
  } catch (error) {
    yield put({
      type: routines.saveChecklistItems.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getSections() {
  try {
    const sectionsList = yield call(decisionsApi.getSections);
    yield put({
      type: routines.getSections.SUCCESS,
      payload: {
        sectionsList
      }
    });
  } catch (error) {
    yield put({
      type: routines.getSections.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getSectionChecklistItemsForDeal({ payload }) {
  const { dealId, sectionId } = payload;
  try {
    const sectionChecklistItemsForDeal = yield call(
      decisionsApi.getSectionChecklistItemsForDeal,
      dealId,
      sectionId
    );
    yield put({
      type: routines.getSectionChecklistItemsForDeal.SUCCESS,
      payload: {
        sectionChecklistItemsForDeal
      }
    });
  } catch (error) {
    yield put({
      type: routines.getSectionChecklistItemsForDeal.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getLookupItems({ payload }) {
  const { inputSource } = payload;
  try {
    const lookupItems = yield call(decisionsApi.getLookupItems, inputSource);
    yield put({
      type: routines.getLookupItems.SUCCESS,
      payload: {
        lookupItems
      }
    });
  } catch (error) {
    yield put({
      type: routines.getLookupItems.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getLookupLists({ payload }) {
  const { flowId } = payload;
  try {
    const lookupLists = yield call(decisionsApi.getLookupLists, flowId);
    yield put({
      type: routines.getLookupLists.SUCCESS,
      payload: {
        lookupLists
      }
    });
  } catch (error) {
    yield put({
      type: routines.getLookupLists.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getSubclassList({ payload }) {
  const { inputSource } = payload;
  try {
    const subclassList = yield call(decisionsApi.getLookupItems, inputSource);
    yield put({
      type: routines.getSubclassList.SUCCESS,
      payload: {
        subclassList
      }
    });
  } catch (error) {
    yield put({
      type: routines.getSubclassList.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getCurrencyList({ payload }) {
  const { inputSource } = payload;
  try {
    const currencyList = yield call(decisionsApi.getLookupItems, inputSource);
    yield put({
      type: routines.getCurrencyList.SUCCESS,
      payload: {
        currencyList
      }
    });
  } catch (error) {
    yield put({
      type: routines.getCurrencyList.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getIndustryFocusList({ payload }) {
  const { inputSource } = payload;
  try {
    const industryFocusList = yield call(
      decisionsApi.getLookupItems,
      inputSource
    );
    yield put({
      type: routines.getIndustryFocusList.SUCCESS,
      payload: {
        industryFocusList
      }
    });
  } catch (error) {
    yield put({
      type: routines.getIndustryFocusList.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getJurisdicationList({ payload }) {
  const { inputSource } = payload;
  try {
    const jurisdicationList = yield call(
      decisionsApi.getLookupItems,
      inputSource
    );
    yield put({
      type: routines.getJurisdicationList.SUCCESS,
      payload: {
        jurisdicationList
      }
    });
  } catch (error) {
    yield put({
      type: routines.getJurisdicationList.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getRightToApprovedFundExtensionList({ payload }) {
  const { inputSource } = payload;
  try {
    const rightToApprovedFundExtensionList = yield call(
      decisionsApi.getLookupItems,
      inputSource
    );
    yield put({
      type: routines.getRightToApprovedFundExtensionList.SUCCESS,
      payload: {
        rightToApprovedFundExtensionList
      }
    });
  } catch (error) {
    yield put({
      type: routines.getRightToApprovedFundExtensionList.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getThresholdList({ payload }) {
  const { inputSource } = payload;
  try {
    const thresholdList = yield call(decisionsApi.getLookupItems, inputSource);
    yield put({
      type: routines.getThresholdList.SUCCESS,
      payload: {
        thresholdList
      }
    });
  } catch (error) {
    yield put({
      type: routines.getThresholdList.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getEntityTypeList({ payload }) {
  const { inputSource } = payload;
  try {
    const entityTypeList = yield call(decisionsApi.getLookupItems, inputSource);
    yield put({
      type: routines.getEntityTypeList.SUCCESS,
      payload: {
        entityTypeList
      }
    });
  } catch (error) {
    yield put({
      type: routines.getEntityTypeList.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getExpectedSizeList({ payload }) {
  const { inputSource } = payload;
  try {
    const expectedSizeList = yield call(
      decisionsApi.getLookupItems,
      inputSource
    );
    yield put({
      type: routines.getExpectedSizeList.SUCCESS,
      payload: {
        expectedSizeList
      }
    });
  } catch (error) {
    yield put({
      type: routines.expectedSizeList.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getDealsForGpList({ payload }) {
  const { email } = payload;
  try {
    const dealsForGpList = yield call(decisionsApi.getDealsByGp, email);
    yield put({
      type: routines.getDealsForGpList.SUCCESS,
      payload: {
        dealsForGpList
      }
    });
  } catch (error) {
    yield put({
      type: routines.getDealsForGpList.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* getNegotiationList({ payload }) {
  try {
    const negotiationList = yield call(
      decisionsApi.getNegotiationHistoryForQuestion,
      payload
    );
    yield put({
      type: routines.getNegotiationList.SUCCESS,
      payload: {
        negotiationList
      }
    });
  } catch (error) {
    yield put({
      type: routines.getNegotiationList.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* createNegotiationHistory({ payload = {} }) {
  try {
    const negotiationResult = yield call(
      decisionsApi.createNegotiationHistory,
      payload
    );
    yield put({
      type: routines.createNegotiationHistory.SUCCESS,
      payload: negotiationResult
    });
  } catch (error) {
    yield put({
      type: routines.createNegotiationHistory.FAILURE,
      payload: error,
      error: true
    });
  }
}

function* editNegotiationHistory({ payload = {} }) {
  try {
    const { negotiationRequest } = payload;
    const negotiationResult = yield call(
      decisionsApi.editNegotiationHistory,
      negotiationRequest
    );
    yield put({
      type: routines.editNegotiationHistory.SUCCESS,
      payload: negotiationResult
    });
  } catch (error) {
    yield put({
      type: routines.editNegotiationHistory.FAILURE,
      payload: error,
      error: true
    });
  }
}

export default function* decisionsSaga() {
  yield takeLatest(
    routines.getAllChecklistItemsForDealList.TRIGGER,
    getAllChecklistItemsForDeal
  );
  yield takeLatest(
    routines.getChecklistItemsForQuestionList.TRIGGER,
    getChecklistItemsForQuestion
  );
  yield takeLatest(
    routines.getChecklistItemsForDealAndQuestionList.TRIGGER,
    getChecklistForDealAndQuestion
  );
  yield takeLatest(routines.getQuestionsList.TRIGGER, getQuestions);
  yield takeLatest(
    routines.getChecklistForDealList.TRIGGER,
    getChecklistForDeal
  );
  yield takeLatest(routines.saveChecklistItems.TRIGGER, saveChecklistItems);
  yield takeLatest(routines.getSections.TRIGGER, getSections);
  yield takeLatest(
    routines.getSectionChecklistItemsForDeal.TRIGGER,
    getSectionChecklistItemsForDeal
  );
  yield takeLatest(routines.getLookupItems.TRIGGER, getLookupItems);
  yield takeLatest(routines.getLookupLists.TRIGGER, getLookupLists);
  yield takeLatest(routines.getSubclassList.TRIGGER, getSubclassList);
  yield takeLatest(routines.getCurrencyList.TRIGGER, getCurrencyList);
  yield takeLatest(routines.getIndustryFocusList.TRIGGER, getIndustryFocusList);
  yield takeLatest(routines.getJurisdicationList.TRIGGER, getJurisdicationList);
  yield takeLatest(routines.getExpectedSizeList.TRIGGER, getExpectedSizeList);
  yield takeLatest(
    routines.getRightToApprovedFundExtensionList.TRIGGER,
    getRightToApprovedFundExtensionList
  );
  yield takeLatest(routines.getThresholdList.TRIGGER, getThresholdList);
  yield takeLatest(routines.getEntityTypeList.TRIGGER, getEntityTypeList);
  yield takeLatest(routines.getDealsForGpList.TRIGGER, getDealsForGpList);

  yield takeLatest(routines.getNegotiationList.TRIGGER, getNegotiationList);
  yield takeLatest(
    routines.createNegotiationHistory.TRIGGER,
    createNegotiationHistory
  );
  yield takeLatest(
    routines.editNegotiationHistory.TRIGGER,
    editNegotiationHistory
  );
}
